import {Dimensions, Platform} from "react-native";
import Intercom, { boot as intercomSdkBoot, show as intercomSdkShow } from '@intercom/messenger-js-sdk';
import { store } from "../redux/store";
import { setAngularState } from "../redux/rootManagerSlice";
import { openAngularPopup } from "./IframeIntegrationServices";
import { loginWithToken } from "../redux/authSlice";
import {fetchApi, getWebHeadersJson} from "./HTTP";
import {ArrivalStatuses, BoxTypes, MembershipTypes, Roles, translations} from "../Configs/DatabaseConsts";
import moment from "moment";
import {Colors} from "../styles/Colors";
import { isRTL, t } from "./i18n";
import {
    getScheduleNote,
    handleAvailabilitiesAddons, handleAvailabilityEventLogic,
    handleSpaceAvailabilities,
    mobiRepeatDays
} from "./ScheduleService";
import {
    AGGREGATOR_TYPE,
    EMAIL,
    LEAD_TYPE, paymentLogs,
    PUSH,
    SMS,
    STAFF_TYPE,
    USER_FIELDS,
    USER_SITE_FIELDS,
    userTypes,
    WHATSAPP
} from "./ConstHelper";
import i18next from "i18next";
import { LIMITED_PACKAGE_MODAL, openModal } from "../redux/modalManagerSlice";
import {autoMessageTypes} from "../components/Structure/Schedule/Popups/ScheduleSettings/SettingsConfig";
import {getCountryCallingCode} from "react-phone-number-input";
import {
    flowOptions,
    getFlowEndpoint,
    getRequestReadyValues
} from "../components/Structure/Schedule/Popups/CreateEvent/FlowOptions";
import {useSelector} from "react-redux";
import orderBy from "lodash-es/orderBy";
import sortBy from "lodash-es/sortBy";
import { Statuses } from "../Configs/DatabaseConsts";
import { HUGIM_FROM_TRACK } from "./ConstHelper";
import { categoryTypes } from "../redux/ScheduleSlice";

const checkIsMobile = () => {
    const screenSize = Dimensions.get('screen').width;
    const MOBILE_MAX_SCREEN_SIZE = 600;
    return screenSize <= MOBILE_MAX_SCREEN_SIZE;
};

const checkIsTablet = () => {
    const screenSize = Dimensions.get('screen').width;
    const MOBILE_MAX_SCREEN_SIZE = 600;
    const TABLET_MAX_SCREEN_SIZE = 1100;
    return screenSize >= MOBILE_MAX_SCREEN_SIZE && screenSize <= TABLET_MAX_SCREEN_SIZE;
};

export const getKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value);

export const isMobile = checkIsMobile();
export const isTablet = checkIsTablet();

export const locationCheck = () => fetch("https://api.ipstack.com/check?access_key=fa539341cace9c3eba25e238ccbae6f7").then(res => res.json()).catch(err => err);

export const cloudflareLocationCheck = () => fetch("https://www.cloudflare.com/cdn-cgi/trace").then(res => res.text()).catch(err => err);

export const getFileExtension = (fileName) => fileName?.split('.').pop()?.toLowerCase();

export const isPdfFile = (file) => getFileExtension(file?.name) === 'pdf' || file?.type === 'application/pdf';

export const getTotalFilesSize = (files) => (files ?? []).reduce((sum, file) => sum + (file?.size || 0), 0);

export const generateUpgradeLink = (box, user, isFitnessType) => {
    const fitnessConcat = isFitnessType ? '-fitness' : '';
    const userPackage = box?.packages && box.packages.name.toLowerCase();
    const isIL = box?.locations_box[0].country_code === 'IL';
    let packageUrl = '';
    let fixedLink = '';
    if (userPackage) {
        packageUrl += isIL ? 'pricing-' : 'product-';
        if (userPackage.includes('basic')) {
            packageUrl += (isIL && !isFitnessType ? 'free-basic' : 'basic-plan') + fitnessConcat;
        }
        else if (userPackage.includes('standard')) {
            packageUrl += "standard-plan" + fitnessConcat;
        }
        else if (userPackage.includes('trial mode max')) {
            fixedLink = 'https://www.arbox.co.il/platform/pricing-free-plan-max';
        } else if (userPackage.includes('trial mode tailor-brands') || userPackage.includes('free account - tailor')) {
            fixedLink = 'http://www.arboxapp.com/platform/product---basic-plan---taylor';
        } else if (userPackage.includes('self employee')) {
            fixedLink = 'https://www.arbox.co.il/platform/pricing-self-employed';
        } else {
            packageUrl += 'free-plan' + fitnessConcat;
        }
    } else {
        packageUrl = 'free-plan' + fitnessConcat;
    }
    if (box.id && user.user_fk) {
        const queryString = '?custom1=' + box.id +
            '&custom2=' + user.user_fk +
            '&customer_last_name=' + box.name +
            '&company_name=' + box.name +
            '&email_address=' + user.email +
            '&phone_number=' + box.phone +
            '&address=' + box.address +
            '&city=' + box.city +
            '&state=' + box.state +
            '&country=' + box.country;
        const url = fixedLink || ((isIL ? 'https://www.arbox.co.il/platform/' : 'https://www.arboxapp.com/platform/') + packageUrl);
        return url + queryString
    }
    return null;
}

export const getThankYouPageLink = async (box) => {
    const result = await fetchApi('getPackages', 'GET', null, false, true);

    const baseLink = "https://www.arboxapp.com/platform/purchase-thank-you-";
    const userPackage = result.box.packages.name.toLowerCase();
     console.log("userPackage " , userPackage);

    // if (!userPackage || userPackage.includes('free') || userPackage.includes('trial'))
    //     console.log("free/trial pack");
    //     return baseLink;
    if (userPackage.includes('basic'))
        return baseLink + 'basic';
    if (userPackage.includes('standard'))
        return baseLink + 'standard';
    if (userPackage.includes('pro'))
        return baseLink + 'pro';
    return baseLink + 'basic';
}

export const handleTimeCardPopup = (dispatch) => {
    dispatch(setAngularState({
        modalSrc: openAngularPopup('popupHandler?type=timeCard')
    }));
}

export const pushToDataLayer = (eventName) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': eventName
    });
}

export const sendDataEvent = (eventName, properties) => {
    try {
        if (store.getState().auth?.data?.originalUser) {
            return;
        };
        window.mixpanel?.track?.(eventName, properties);
    } catch (error) {
        console.log('mixpanel track event error');
    }
}

export const freshpaintIdentify = (box, user) => {
    window.mixpanel?.identify?.(user.email);
    window.mixpanel?.people?.set?.({
        "user_fk": user.user_fk,
        "$first_name": user.first_name,
        "$last_name": user.last_name,
        "$phone": user.phone,
        "boxId": box.id,
        "role_fk": user.roles,
        "$country_code": box.locations_box[0].country_code,
        "package_name": box.packages?.name,
        "box_type": box.box_type.type,
        "box_name": box.name,
        "$email": user.email,
        "$name": `${user.first_name} ${user.last_name || ''}`,
    });
}

export const freshpaintReset = () => {
    window.mixpanel?.reset?.();
}

const getFormattedPhone = (phone, countryCode) => {
    try {
        if (!phone) return phone;
        const onlyNumbers = phone.replace(/\D/g, '');
        const callingCode = getCountryCallingCode(countryCode);
        if (onlyNumbers.startsWith('0')) {
            return `+${callingCode}${onlyNumbers.slice(1)}`;
        }
        if (onlyNumbers.startsWith(callingCode)) {
            return `+${onlyNumbers}`;
        }
        return `+${callingCode}${onlyNumbers}`;
    } catch (error) {
        console.log("error", error)
        return phone;
    }
}

// Tracks whether the SDK's first-call loader injection has run.
// Boot strategy:
//   - If window.Intercom already exists (GTM loaded it, or SDK already injected the loader):
//       use boot() directly. This is the canonical way to (re-)boot with identifying data.
//   - Else, first call only: call SDK's Intercom() which injects the loader script.
//     This sets up window.Intercom so subsequent calls can use boot().
let sdkLoaderInjected = false;

export const callIntercomBoot = (payload) => {
    console.log('[Intercom][TEMP] callIntercomBoot', {
        windowIntercomType: typeof window.Intercom,
        sdkLoaderInjected,
        app_id: payload?.app_id,
        has_user_id: !!payload?.user_id,
        has_jwt: !!payload?.intercom_user_jwt,
        has_user_hash: !!payload?.user_hash,
    });
    if (typeof window.Intercom === 'function') {
        console.log('[Intercom][TEMP] callIntercomBoot path: existing window.Intercom -> boot()');
        intercomSdkBoot(payload);
    } else if (!sdkLoaderInjected) {
        console.log('[Intercom][TEMP] callIntercomBoot path: first call -> Intercom() loader injection');
        Intercom(payload);
        sdkLoaderInjected = true;
    } else {
        // Loader injected but window.Intercom not yet the real function;
        // boot() will queue the call into the loader stub.
        console.log('[Intercom][TEMP] callIntercomBoot path: loader injected, window.Intercom not ready -> boot() (queued)');
        intercomSdkBoot(payload);
    }
};

// Mirror of intercomSdkBoot but readable for callers that check init state.
const isIntercomReady = () => typeof window.Intercom === 'function' || sdkLoaderInjected;

// Reads the JWT 'exp' claim without external libs. Returns 0 on malformed input.
const getJwtExpSeconds = (token) => {
    try {
        const payload = token.split('.')[1];
        if (!payload) return 0;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = JSON.parse(atob(base64));
        return decoded.exp ?? 0;
    } catch {
        return 0;
    }
};

const isJwtExpired = (token, bufferSec = 60) => {
    const exp = getJwtExpSeconds(token);
    if (!exp) return true;
    return exp - Math.floor(Date.now() / 1000) < bufferSec;
};

// Returns a non-expired Intercom JWT or null if not yet rolled out for this env.
// Server controls rollout: when the backend env var is unset, getUserData returns
// intercom_jwt: null and this helper returns null, so callers fall back to user_hash.
export const ensureFreshIntercomJwt = async () => {
    const cached = store.getState().user?.user?.intercom_jwt;
    if (cached && !isJwtExpired(cached)) {
        const exp = getJwtExpSeconds(cached);
        console.log('[Intercom] using cached JWT, exp in', exp - Math.floor(Date.now() / 1000), 's');
        return cached;
    }
    if (cached) {
        console.log('[Intercom] cached JWT expired or near-expiry, fetching fresh');
    } else {
        console.log('[Intercom] no cached JWT on user, calling messenger/jwt');
    }
    try {
        const response = await fetchApi('messenger/jwt', 'get', null, false, true);
        if (response?.intercom_jwt) {
            const exp = getJwtExpSeconds(response.intercom_jwt);
            console.log('[Intercom] fetched fresh JWT, exp in', exp - Math.floor(Date.now() / 1000), 's');
        } else {
            console.log('[Intercom] messenger/jwt returned null - secret not configured on server, will fall back to user_hash');
        }
        return response?.intercom_jwt ?? null;
    } catch (error) {
        console.error('[Intercom] failed to refresh JWT', error);
        return null;
    }
};

export const intercomIdentify = async (box, user) => {
    console.log('[Intercom] intercomIdentify start', {
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        user_fk: user.user_fk,
        user_has_intercom_jwt: !!user.intercom_jwt,
        user_has_chat_token: !!user.chat_token,
    });
    try {
    const jwt = user.intercom_jwt && !isJwtExpired(user.intercom_jwt)
        ? user.intercom_jwt
        : await ensureFreshIntercomJwt();

    const baseSettings = {
        ...window.intercomSettings,
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        boxId: box.id,
        clubName: box.name,
        box_type: box.box_type?.type,
        package_name: box.packages?.name,
        package_id: box.packages_id,
        White_label_link: box.white_label_property,
        payment_service: box.box_payment_services?.payment_service,
        user_fk: user.user_fk,
        user_id: user.user_fk,
        schedule_link: generateSiteLink('schedule', {referer: 'site'}),
        country_code: box.locations_box[0].country_code,
        company: {
            id: box.id,
            name: box.name,
            package: box.packages?.name,
            company_box_type: box.box_type?.type,
        },
    };

    if (jwt) {
        console.log('[Intercom] booting in JWT mode (intercom_user_jwt)');
        // Sensitive attributes (email, phone, role, company) are carried inside the
        // signed JWT - do NOT duplicate them in the unsigned boot payload.
        window.intercomSettings = {
            ...baseSettings,
            intercom_user_jwt: jwt,
        };
    } else {
        console.log('[Intercom] booting in LEGACY mode (user_hash fallback)');
        window.intercomSettings = {
            ...baseSettings,
            email: user.email,
            phone: getFormattedPhone(user.phone, box.locations_box[0].country_code),
            role_fk: user?.roles?.filter((role) => role !== Roles?.BASICMANAGER).join(',') ?? "",
            user_hash: user.chat_token,
        };
    }

    callIntercomBoot({ ...window.intercomSettings });
    console.log('[Intercom] boot dispatched', window.intercomSettings);
    } catch (error) {
        console.error('[Intercom][TEMP] intercomIdentify threw after start (async)', error);
    }
};


export const smartlookIdentify = (box, user) => {
    window.smartlook?.('identify', user.email, {
        box_id: box.id,
        box_name: box.name,
        email: user.email,
        user_fk: user.user_fk,
        first_name : user.first_name,
        last_name : user.last_name,
        ub_created: user.created_at
    });
}

export const fullviewIdentify = (box, user) => {
    window.$fvIdentity = {
        id: user.user_fk,
        name: `${user.first_name} ${user.last_name}`,
        email: user.email,
        disableReplaysForUser: false,
        Box_fk: box.id,
        Phone: user.phone
    };
}



export const intercomLanguageOnChange = async (lang) => {
    // Only reboot if user is already identified - otherwise we're triggered by
    // the initial i18n init before login and there's no user context yet.
    if (!isIntercomReady() || !window.intercomSettings?.user_id) {
        console.log('[Intercom] intercomLanguageOnChange skipped', { lang, ready: isIntercomReady(), hasUser: !!window.intercomSettings?.user_id });
        return;
    }
    console.log('[Intercom] intercomLanguageOnChange firing reboot', { lang });
    const alignment = lang === 'he' ? 'left' : 'right';
    const language_override = lang === 'he' ? 'he' : 'en';
    const jwt = await ensureFreshIntercomJwt();
    callIntercomBoot({
        ...window.intercomSettings,
        ...(jwt ? { intercom_user_jwt: jwt } : {}),
        alignment,
        language_override,
    });
}

export const checkIfAngularLoggedIn = async (auth, dispatch) => {
    if (!auth) {
        const user = localStorage.getItem('ls.user') ? JSON.parse(localStorage.getItem('ls.user')) : null;
        if (user && user.token) {
            dispatch(loginWithToken({ token: user.token, isOldServerToken: true }));
        }
    }
}

// service worker - notifications

const askPermission = () => {
    // Legacy support Notification.requestPermission can either return a promise, or accept a callback(deprecated)
    // Side note: most likley callback impls of Notification.requestPermission might not have native promises
    return new Promise(function (resolve, reject) {
        const returnedPromise = Notification.requestPermission(function (result) {
            resolve(result);
        });
        if (returnedPromise)
            returnedPromise.then(resolve, reject);
    }).then(function (result) {
        if (result !== 'granted') {
            throw new Error('no permission');
        }
    });
}

const saveSubscription = (pushSubscription) => {
    return fetchApi('webPush/subscribe', 'POST', pushSubscription, false, true);
}

export const urlBase64ToUint8Array = (base64String) => {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

const subscribeUser = (registration) => {
    return askPermission().then(function () {
        const subscribeOptions = {
            userVisibleOnly: true, // MUST true always
            applicationServerKey: urlBase64ToUint8Array('BKXADcOjGugnOKvSKK4DKluGn9QJ-IBcEA_N6kWtY3awYBx4P7MAOW0UE6jWhgRUzsDxnrHt6SVbxED8pVZsWTI')
        };
        return registration.pushManager
            .subscribe(subscribeOptions)
            .then(saveSubscription);
    })
}

export const setupPushSubscription = async () => {
    try {
        console.log('setting up')
        if (!('serviceWorker' in navigator)) {
            throw new Error('Service Worker not supported');
        }
        console.log('setting up 1')
        const registration = await navigator.serviceWorker.register('./webPushService.js');
        console.log('Service Worker registered');
        // Check permission
        const permission = await Notification.requestPermission();
        console.log('permission', permission)
        const existingSubscription = await registration.pushManager.getSubscription();
        console.log('existingSubscription', existingSubscription)

        if(permission === 'granted') {
            console.log('subscribeUser')
            await subscribeUser(registration);
        } else if(permission === 'blocked' || permission === 'denied') {
            /* the user has previously denied push. Can't reprompt. */
        } else {

        }

    } catch (err) {
        console.error('Error setting up push notification:', err);
    }
}


export const serviceWorkerRegister = () => {
    if ("serviceWorker" in navigator && "Notification" in window) {
        console.log('in navigation', navigator.serviceWorker);
        navigator.serviceWorker.register('./sw.js').then((reg) => {
            if (Notification.permission === "granted") {
                /* do our magic */
                reg.pushManager.getSubscription().then(function (sub) {
                    //TODO ADD USER UI?
                    if (sub === null) {
                        // Update UI to ask user to register for Push
                        subscribeUser(reg);
                    } else {
                        // We have a subscription, update the database
                        //TODO We handle updates on pushsubscriptionchange event || Consider removing this func call
                        subscribeUser(reg);
                    }
                });
            } else if (Notification.permission === "blocked") {
                /* the user has previously denied push. Can't reprompt. */
            } else if (
                Notification.permission !== "denied" ||
                Notification.permission === "default"
            ) {
                /* show a prompt to the user */
                Notification.requestPermission(function (permission) {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        subscribeUser(reg);
                        var notification = new Notification(
                            "תתחדשו! מעתה תהנו מתזכורות לפני מועד המשימה"
                        );
                    }
                });
            }
        })
    }
}

export const generateSiteLink = (path, params, sendEvent, newSiteQueryAddons = null) =>  {
    if (sendEvent) {
        sendDataEvent('Open or copy site link')
    }
    const box = store.getState().box.box
    var identifier = box.external_url_id;
    var lang = box?.locations_box[0].country_code === 'IL' ? 'he' : 'en';
    if(box.isBoxHasNewSite && params.scheduleType !== 'workshops') return translateToSiteV2(path, params, newSiteQueryAddons)
    const queries = params.scheduleType && `&scheduleType=${params.scheduleType}`
    return `${process.env.REACT_APP_ARBOX_SITE_URL}${path}?identifier=${identifier}&whitelabel=${box.white_label_property?.app_names?.name || 'Arbox'}&referer=${params.referer}&lang=${lang}${queries ?? ''}`;
}

const translateToSiteV2 = (path, params, newSiteQueryAddons = null) => {
    let route = null
    if(path === 'schedule') {
        if(!params.scheduleType || params.scheduleType === 'schedule') {
            route = 'group'
        } else if(params.scheduleType === 'appointment') {
            if(params.availabilityType === 'SPACE_AVAILABILITY_TYPE') {
                route = 'space-appointment'
            } else {
                route = 'staff-appointment'
            }
        }
    } else if(path === 'shop' || path === 'cart') {
        route = 'membership'
        if(path === 'shop/item/') {
            const itemId = path.split('/').pop()
            route = `/membership/${itemId}`
        }
    }
    return generateSiteV2Link(route, params, newSiteQueryAddons)
}

export const generateSiteV2Link = (route, params = {}, newSiteQueryAddons = null) => {
    const box = store.getState().box.box
    const identifier = box.external_url_id;
    const lang = store.getState().userSettings.lang.language === 'English' ? 'en' : 'he'
    let searchParams = `whitelabel=${box.white_label_property?.app_names?.name || 'Arbox'}`
    if(lang) searchParams += `&lang=${lang}`
    if(params.location) searchParams += `&location=${params.location}`
    if(params.referer) searchParams += `&referrer=${params.referer}`
    if(newSiteQueryAddons) searchParams += newSiteQueryAddons
    return `${process.env.REACT_APP_ARBOX_NEW_SITE_PREFIX}${identifier}.${process.env.REACT_APP_ARBOX_NEW_SITE_URL}${route}?${searchParams}`;
}

export const adjustSchedulesToMobiscrollObj = (schedules) => {
    schedules = schedules.map(event => {
        event.start = moment(event.date_time.date, 'YYYY-MM-DD HH:mm')
        event.end = moment(event.end_date_time.date, 'YYYY-MM-DD HH:mm')
        event.color = event.box_categories?.category_color ?? Colors.newDesign.white
        event.title = event.box_categories?.name ?? event.place ?? t('blocked-time-event')
        event.resource = event.coach_fk
        event.scheduleNote = getScheduleNote(event)
        return event;
    })
    return schedules
}

export const adjustAvailabilityToMobiscrollObj = (availabilities) => {
    let addOns = [];
    availabilities = availabilities.filter(event => {
        event = adjustSingleAvailabilityToMobiscrollObj(event)
        event = handleAvailabilityEventLogic(event);
        if(event?.overrideAddOns) {
            addOns.push(...event.overrideAddOns)
        }
        return event
    })
    availabilities.push(...addOns);
    return availabilities
}

export const adjustSingleAvailabilityToMobiscrollObj = (event) => {
    event.start = moment(`${event.date} ${event.start_time}`, 'YYYY-MM-DD HH:mm:ss')
    event.end = moment(`${event.date} ${event.end_time}`, 'YYYY-MM-DD HH:mm:ss')
    event.color = Colors.newDesign.white
    event.title = `${event.first_name} ${event.last_name}`
    if(event.repeat) {
        event.recurring = {
            repeat: 'weekly',
            from: event.date
        }
    }
    return event;
}

export const adjustMixAvailabilitiesToMobiscrollObj = (availabilities, params = {}) => {
    const availabilitiesWithMobiProps = adjustAvailabilityToMobiscrollObj(availabilities)

    const from = moment(params.from);
    const to = moment(params.to);
    let currentDate = moment(params.from);
    let accurateRes = []

    while (currentDate.isSameOrBefore(to, 'day')) {
        const res = handleAvailabilitiesAddons(availabilitiesWithMobiProps, currentDate.format(dbDateFormat))
        accurateRes = [...accurateRes, ...res]
        currentDate.add(1, 'day');
    }

    const colors = accurateRes.reduce((acc, ava) => {
        if(!ava.repeat) {
            const date = moment(ava.date, dbDateFormat);
            if(!(date.isSameOrAfter(from, 'day') && date.isSameOrBefore(to, 'day'))) {
                return acc
            }
            delete ava.repeat
        }
        if(acc.some(item => item.id === ava.id)) return acc
        if(ava.recurring) {
            ava.start = ava.start_time
            ava.end = ava.end_time
            ava.recurring.weekDays = mobiRepeatDays[ava.day_of_week]
        } else {
            const startDateTime = moment(`${ava.date} ${ava.start_time}`, `${dbDateFormat} ${dbTimeFormat}`).toDate();
            const endDateTime = moment(`${ava.date} ${ava.end_time}`, `${dbDateFormat} ${dbTimeFormat}`).toDate();
            ava.start = startDateTime
            ava.end = endDateTime
        }
        return [...acc, {...ava, resource: ava.coach?.user_fk, background: Colors.newDesign.white, allDay: false, title: ''}]
    }, [])

    return colors
}

export function isWeb() {
    return Platform.OS.toLowerCase() === 'web';
}

export const generateEmbedHTML = (link) => {
    let elem = document.createElement("iframe");
    elem.setAttribute("width", "100%");
    elem.setAttribute("height", "600");
    elem.setAttribute("src", link);
    return elem.outerHTML
}

export const camelize = (str) => {
    if (!str) return '';
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return "";
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
}

export const snakeToCamel = str =>
    str.toLowerCase().replace(/([-_][a-z])/g, group =>
    group
        .toUpperCase()
        .replace('-', '')
        .replace('_', '')
);

export const shareLinkOnMobile = async (title, text, url) => {
    const shareData = {
        title: title,
        text: text,
        url: url
    }
    try {
        await navigator.share(shareData);
    } catch(err) {
        console.error("could not open navigation.share");
        await navigator.clipboard.writeText(url);
    }
}

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    }
    catch(err) {
        return false;
    }

}

export const getQueryObject = (search) => {
    return JSON.parse('{"' + decodeURI(search.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
}

export const getRedirectLinkToStripeConnect = (user, box) => {
    var state = {
        boxId: box.id,
        locationId: box.locations_box[0].id,
        stripe: true
    }
    return "https://connect.stripe.com/oauth/v2/authorize?scope=read_write&response_type=code&client_id=" + process.env.REACT_APP_STRIPE_CLIENT_ID +
        "&stripe_landing=register&state=" + JSON.stringify(state) +
        "&stripe_user[email]=" + user.email +
        "&stripe_user[url]=" +
        "&stripe_user[phone_number]=" + user.phone +
        "&stripe_user[business_name]=" + box.name +
        "&stripe_user[first_name]=" + user.first_name +
        "&stripe_user[last_name]=" + user.last_name +
        "&stripe_user[street_address]=" +
        "&stripe_user[city]=" + user.city +
        "&stripe_user[state]=" +
        "&stripe_user[zip]=" +
        "&stripe_user[physical_product]=false" +
        "&stripe_user[country]=" + user.country +
        "&stripe_user[currency]=" + box.locations_box[0].currency +
        "&redirect_uri=" + window.location.origin +  "/from-stripe-redirect";
}

export const checkIfAgentIsAllowed = () => {
	const webviews = ["FBAN", "FBAV"];
	const userAgentToLower = window.navigator?.userAgent?.toUpperCase();
	let isAllowed = true;
	webviews.forEach(webviewType =>
		isAllowed = isAllowed && !userAgentToLower.includes(webviewType)
	);
	return isAllowed;
}

export const getBorderColorByType = (type) => {
    switch(type) {
        case STAFF_TYPE:
            return Colors.newDesign.staffMemberBorder;
        case AGGREGATOR_TYPE:
            return Colors.newDesign.freefitBorder;
        case LEAD_TYPE:
            return Colors.newDesign.leadBorder;
        default:
            return;
    }
}

export const sortBetweenDatesDESC = (datesArray) => {
    return datesArray.sort(function (left, right) {
        return moment.utc(left.timeStamp).diff(moment.utc(right.timeStamp))
    });
}

export const getMessageParams = (params) => {
    return params.message_content.replaceAll('[', '[{').replaceAll(']', '}]').split(/[\[\]]/g).map((s) => {
        if (new RegExp(/\{.*\}/g).test(s)) {
            const tags = getMessageTags()
            const tag = tags.find(tag => s === `{${t(tag.label)}}`)
            if(tag) return ({key: tag.label, keyDB: tag.id})
        }
        return ({text: s.replaceAll(/ +/g, ' ')}) // replace multiple spaces with only one space
    })
}

export const fitnessBoxTypes = [
    BoxTypes.CROSSFIT, BoxTypes.GROUP_TRAINING, BoxTypes.YOGA, BoxTypes.PILATES, BoxTypes.OUTDOOR,
    BoxTypes.MARTIAL_ARTS, BoxTypes.CYCLING, BoxTypes.DANCE_STUDIO, BoxTypes.RUN, BoxTypes.OTHER,
    BoxTypes.CLIMBING, BoxTypes.PERSONAL_TRAINING, BoxTypes.GYM, BoxTypes.CORPORATE_TRAINING,
    BoxTypes.COMMUNITY_CENTER_POOL, BoxTypes.TENNIS, BoxTypes.SURFING, BoxTypes.BARRE, BoxTypes.NINJA,
    BoxTypes.POLE_FITNESS, BoxTypes.SWIMMING , BoxTypes.BATTING_CAGES,
    BoxTypes.SOCCER_FOOTBALL, BoxTypes.FOOTVOLLEY, BoxTypes.VOLLEYBALL];

export const beautyBoxTypes = [
    BoxTypes.NAIL_SALON, BoxTypes.WAXING_SALON, BoxTypes.HAIR_SALON, BoxTypes.BARBER_SHOPS,
    BoxTypes.BEAUTY_SALON, BoxTypes.TANNING_STUDIO, BoxTypes.BEAUTICIAN,];

export const wellnessBoxTypes = [BoxTypes.CHIROPRACTORS, BoxTypes.SPA_MASSAGE,  BoxTypes.POSTPARTUM];

export const wellnessClinicBoxTypes = [BoxTypes.NUTRITIONISTS, BoxTypes.PHYSIOTHERAPISTS, BoxTypes.PSYCHOLOGISTS, BoxTypes.CLINICS, BoxTypes.HYDROTHERAPY];

export const educationBoxTypes = [BoxTypes.MUSICIANS, BoxTypes.TUTORS, BoxTypes.LANGUAGE_TEACHERS,  BoxTypes.PROFESSIONAL_COURSES,
    BoxTypes.ONLINE_COURSES, BoxTypes.CHILD_TUTORS, BoxTypes.EDUCATION ];

export const otherBoxTypes = [
    BoxTypes.BANDS, BoxTypes.HANDYMAN, BoxTypes.DOG_WALKER, BoxTypes.SHOOTING_RANGE,
    BoxTypes.OTHER, BoxTypes.CERAMIC, BoxTypes.BABYSITTING, BoxTypes.HOUSEKEEPER,
    BoxTypes.TATTOO_STUDIO, BoxTypes.AFTER_SCHOOL_ACTIVITIES, BoxTypes.ARTS,  BoxTypes.CHILD_CARE,
    BoxTypes.DOGS_CARE, BoxTypes.DOGS_TRAINING, BoxTypes.ICE_SKATING, BoxTypes.PLAYGROUND, BoxTypes.SKATING,  BoxTypes.YOUTH_SPORTS, BoxTypes.ARMY_PREP];

export const coachViewDefaultBoxTypes = [
    BoxTypes.NUTRITIONISTS, BoxTypes.PHYSIOTHERAPISTS, BoxTypes.PSYCHOLOGISTS,
    BoxTypes.CHIROPRACTORS, BoxTypes.SPA_MASSAGE,
    BoxTypes.CLINICS, BoxTypes.HYDROTHERAPY
]


export const aspectRatio916 = 0.5625;

export const serviceTypeIcons = {'class': 'fa-users', 'appointment': 'fa-user-clock', 'workshop': 'fa-calendar-range'}

export const firstDaysOfTrial = 3;

export const dbDateFormat = 'YYYY-MM-DD'
export const dbTimeFormat = 'HH:mm:ss'
export const dbDateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

export const getRepeatSessionCount = (repeatConfig, startDate) => {
    if (repeatConfig?.type === 'times') return Number(repeatConfig.times) || 0
    if (repeatConfig?.type !== 'until' || repeatConfig.days?.length !== 1 || !repeatConfig.until || !startDate) return 0
    const start = moment(startDate, dbDateFormat)
    const first = start.clone().day(repeatConfig.days[0])
    if (first.isBefore(start, 'day')) first.add(1, 'week')
    const until = moment(repeatConfig.until, dbDateFormat)
    return first.isAfter(until, 'day') ? 0 : Math.floor(until.diff(first, 'days') / 7) + 1
}

export const isMultiPayForSlotRepeat = (repeatConfig, startDate) => !!repeatConfig?.repeat && (repeatConfig.type === 'times' || (repeatConfig.type === 'until' && getRepeatSessionCount(repeatConfig, startDate) > 0))

export const messageAudienceByType = {
    [PUSH]: ['ActiveMembersMessage', 'StaffMembersMessage', 'PrivateMessage'],
    [SMS]: ['ActiveMembersMessage', 'NonActiveMembersMessage', 'StaffMembersMessage', 'OpenLeadsMessage', 'LostLeadsMessage', 'PrivateMessage'],
    [EMAIL]: ['ActiveMembersMessage', 'NonActiveMembersMessage', 'StaffMembersMessage', 'OpenLeadsMessage', 'LostLeadsMessage', 'PrivateMessage'],
    [WHATSAPP]: ['ActiveMembersMessage', 'StaffMembersMessage', 'PrivateMessage'],
}

export const isBoxIL = () => {
    const box = store.getState().box.box
    return box?.locations_box[0].country_code === 'IL';
}

export const emojisReqex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g


export async function handleShareClick(text, url) {
    const shareData = {
        title: "Arbox",
        text: text,
        url: url
    }
    try {
        await navigator.share(shareData);
    } catch(err) {
        console.error("could not open navigation.share");
        await navigator.clipboard.writeText(url);
    }
}

export const isScheduleException = (error) => {
    return error && (error?.message?.includes('Schedule Exception') || error?.message === 'Schedule Is Full')
}

export const isLimitExceededException = (error) => {
    return error && (error?.message?.includes('limit exceeded'))
}

export const getMessageToUserFromError = (error, joinString = '\n') => {
    if(error && error?.messageToUser) {
        if(Array.isArray(error.messageToUser)) {
            return error.messageToUser.map(errorMsg => `\u2022 ${errorMsg.message}`).join(joinString)
        } else return error.messageToUser
    }
    return ''
}

export const getBoxDateFormat = () => {
    const box = store.getState().box.box;
    return box?.locations_box[0]?.date_format;
}

export const getBoxTimeFormat = () => {
    const box = store.getState().box.box;
    return box?.locations_box[0]?.time_format;
}

export const getLocale = () => {
    const lang = store.getState().userSettings.lang;
    return lang?.language === 'Hebrew' ? 'he' : 'en';
}

export const sortDays = (a, b) => {
    if(isBoxIL()) {
        return a - b
    } else {
        if(a === 0) return 1
        if(b === 0) return -1
        return a - b
    }
}

export const getHourAndMinuteDiff = (startTime, endTime) => {
    const start = moment(startTime, dbTimeFormat)
    const end = moment(endTime, dbTimeFormat)
    const duration = moment.duration(end.diff(start));
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes()) % 60;
    return {hours, minutes, fullLength: duration.asMinutes()}
}

export const isBoxFitnessType = () => {
    const box = store.getState().box.box;
    return fitnessBoxTypes.includes(box.box_type.type)
}

export const isBoxInTrial = () => {
    const box = store.getState().box.box;
    return box.packages?.name.toLowerCase().includes('trial')
}

export const getSessionTypeName = (categoryTypeId) => {
    const categoryTypes = store.getState().schedule.categoryTypes;
    const category = categoryTypes?.find(cat => cat.id === categoryTypeId)
    return category?.name;
}

export const getSessionTypeIdByName = (categoryTypeName) => {
    const categoryTypes = store.getState().schedule.categoryTypes;
    const category = categoryTypes?.find(cat => cat.name === categoryTypeName)
    return category?.id;
}

export const getOrderedEventTypes = (has, allowBothCourses = false) => {
    const categoryTypes = store.getState().schedule.categoryTypes;
    const types = categoryTypes?.reduce((acc, type) => {
        const hideHugimOrWorkshop = (type.name === 'hugim' && !has('hugim')) || (type.name === 'workshop' && has('hugim'))
        if(!allowBothCourses && hideHugimOrWorkshop) return acc
        return {...acc, [type.name]: type}
    },{})
    let coursesType
    if(has('hugim')) {
        coursesType = allowBothCourses ? [types.hugim, types.workshop] : [types.hugim]
    } else {
        coursesType = [types.workshop]
    }
    const courses = [...coursesType, dummyHugimFromTrackEventType]
    return [orderEventTypesBySegment(types, courses), [dummyBlockedEventType]]
}

export const orderEventTypesBySegment = (types, courses) => {
    let mainTypes
    const segment = getBoxSegment(store.getState().box.box)
    switch (segment) {
        case translations.CLINICS:
        case translations.BEAUTY:
            mainTypes = [types.appointment, types.class, ...courses]
            break;
        case translations.GROUPS:
            mainTypes = [...courses, types.class, types.appointment]
            break;
        default:
            mainTypes = [types.class, types.appointment, ...courses]
    }
    return mainTypes
}

export const eventTypePermission = (eventType, has, isLock = false) => {
    switch(eventType) {
        case 'class':
            return isLock ? has('classes') : true
        case 'appointment':
            return has('appointments')
        case 'workshop':
            return has('workshops')
        case 'hugim':
            return has('hugim')
        case 'hugimFromTrack':
            return has('createCourseFromTrack')
        case 'blocked':
            return isLock ? has('blockedEvents') : true
        default:
            return false
    }
}

export const dummyBlockedEventType = {id: null, name: 'blocked'};
export const dummyHugimFromTrackEventType = { id: HUGIM_FROM_TRACK, name: HUGIM_FROM_TRACK };


export const isBoxFree = () => {
    const box = store.getState().box.box;
    return box.packages?.name.toLowerCase().includes('free')
}

export const isStringWithoutEmoji = (str) => {
    if (typeof str !== 'string') return true;
    const regex_emoji = /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u;
    return !regex_emoji.test(str);
}

export const arrayToObject = (objOrArray) => {
    if (!objOrArray)
        return {}
    if (Array.isArray(objOrArray)) {
        return objOrArray.reduce((a, b) => ({...(a || {}), ...(b || {})}), {})
    }
    return objOrArray
}

export const isActive = item => {
    return item?.active === 1;
}

export const noCoaches = staff => {
    return staff?.roles.filter(role => ![Roles.COACH, Roles.BASICMANAGER].includes(role.role))?.length
}

export const onlyCoaches = staff => {
    return staff?.roles.filter(role => [Roles.COACH].includes(role.role))?.length
}

export const personalTasks = (has) => {
    return optionValue =>has('personalTaskOption') ? true : optionValue !== 'personal'
}

export const leadsTasks = (has) => {
    return optionValue => has('leadAddNewTaskLock') ? (optionValue !== 'lost_leads' && optionValue !== 'leads_in_progress') : true
}

export const leadsMessages = (has) => {
    return optionValue => has('addNewLeadLock') ? (optionValue !== 'LostLeadsMessage' && optionValue !== 'OpenLeadsMessage') : true
}

export const SortMembersQuickViewManage = (members) => {
    if(!members || members.length <= 0) return;

    const sortedMembers = members.sort((a, b) => {

        if (a.type === LEAD_TYPE && b.type !== LEAD_TYPE) {
            return -1;
        }
        if (a.type !== LEAD_TYPE && b.type === LEAD_TYPE) {
            return 1;
        }

        if (a.regular_client && !b.regular_client) {
            return -1;
        }
        if (!a.regular_client && b.regular_client) {
            return 1;
        }

        return 0;
    })

    return sortedMembers;
}

export const translateExitNumberToCode = (number, duration = null) => {
    const isTibboOrManaged = checkIsTibboOrManaged();
    switch (number) {
        case 1:
            if (isTibboOrManaged){
                console.log('IM IN TIBBO CASE GATE 1')
                return {
                    open: new TextEncoder().encode(`Opn01,${duration ?? 1}`),
                    close: new TextEncoder().encode('Cls01')
                }
            }
            console.log('NO TIBBO - regular 1')
            return {
                open: new Uint8Array(['65'].map(hex => parseInt(hex, 16))),
                close: new Uint8Array(['6F'].map(hex => parseInt(hex, 16)))
            }
        // return ['65','6F'];
        case 2:
            if (isTibboOrManaged) {
                console.log('IM IN TIBBO CASE GATE 2')
                return {
                    open: new TextEncoder().encode(`Opn02,${duration ?? 1}`),
                    close: new TextEncoder().encode('Cls02')
                }
            }
            console.log('NO TIBBO - regular 2')
            return {
                open: new Uint8Array(['66'].map(hex => parseInt(hex, 16))),
                close: new Uint8Array(['70'].map(hex => parseInt(hex, 16)))
            }
        // return ['66','70'];
        case 3: {
            return {
                open: new TextEncoder().encode(`Opn03,${duration ?? 1}`),
                close: new TextEncoder().encode('Cls03')
            }
        }
        case 4: {
            return {
                open: new TextEncoder().encode(`Opn04,${duration ?? 1}`),
                close: new TextEncoder().encode('Cls04')
            }
        }
    }
}

export const checkIsTibboOrManaged = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const type = searchParams.get('type');
    console.log('type in search PARAMS', type);
    return type === 'tibbo' || type === 'managed';
}


export const checkGate = async(selectedPort) => {
    console.log(selectedPort,'checkGate');
    const optionalPorts = store.getState().accessControl.optionalPorts;
    const settings = store.getState().accessControl.settings;
    const gatesObj = store.getState().accessControl.gatesObj;
    const gatePort = optionalPorts.find((port) => port.label === selectedPort.gate);
    const isTibboOrManaged = checkIsTibboOrManaged();
    console.log('THATS WHAT I FOUND', gatePort);
    console.log('checkGate gatesObj', gatesObj);
    if (gatePort && !gatePort.readable) {
        await gatePort.open({ baudRate: 9600 });
    }
    const duration = isTibboOrManaged ? Math.ceil(settings.gateOpenDuration) : (parseFloat(settings.gateOpenDuration) * 1000)
    let gateWriter;
    if(!gatePort.writable.locked){
        console.log('not locked yet so working?')
         gateWriter = gatePort.writable.getWriter();
    }else{
        console.log('trying writer anyway');
         gateWriter = gatesObj[selectedPort.gate];
    }
    const gateWritable = translateExitNumberToCode(selectedPort.gateNumber || 1, isTibboOrManaged ? duration : null);
    if(gateWriter){
        await gateWriter.write(gateWritable.open.buffer);
        if(!isTibboOrManaged) {
            await new Promise((resolve) => setTimeout(resolve, duration)); // Delay for gate open
            await gateWriter.write(gateWritable.close.buffer);
            // gateWriter.releaseLock();

        }
    }

}

export const getPortNaming = (port) =>{
    console.log('NO TIBBO!! note')
    const usbProductId = port.getInfo().usbProductId;
    const usbVendorId = port.getInfo().usbVendorId;
    // 24597-1027 -- Reader
    if(usbProductId === 24597 || usbVendorId === 1027){
        return `Reader-${usbProductId}-${usbVendorId}`;
    }
    // 65518-1240 -- Gate
    if(usbProductId === 65518 || usbVendorId === 1240){
        return `Gate-${usbProductId}-${usbVendorId}`;
    }
    return `Serial-Port-Gate`;
}

export const getPortNamingTibbo = (port, createUUID = false, index = false,settings = null) => {
    console.log('port info', port.getInfo(),'We in tibbo');
    const searchParams = new URLSearchParams(window.location.search);
    const flip = searchParams.get('flip');
    console.log('flipper', flip);
    const uuid = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    if (createUUID) {
        return `Com-Connection-${uuid}`
    } else {
        console.log('flip:',flip)
        if (index === 0){
            return flip ? settings?.gates[0]?.gate : settings?.gates[0]?.reader;
        }else{
            return flip ? settings?.gates[0]?.reader : settings?.gates[0]?.gate;
        }
    }
}

export const daysLeftHelper = (box) => {
    const currDate =  moment();
    const EndDate =  moment(box.trial_mode?.end_date);
    return EndDate.diff(currDate, 'days') + 1; //Adding 1 because differance is not considering first day as part of the 14 days
}

export async function portWHOMI(port, search = false) {


    try {
        console.log('IN portWHOMI',port);
        if(!port.readable){
            await port.open({baudRate:9600});
        }
        const writer = port.writable.getWriter();
        const reader = port.readable.getReader();
        // Writing to the port
        await writer.write(new TextEncoder().encode("RDI"));
        // writer.releaseLock();
        // Reading from the port
        let keepReading = true;
        let response = '';
        console.log('keep reading starts')
        while (keepReading) {
            const { value, done } = await reader.read();
            if (done) {
                console.log('DONE CALLED',done, value);
                keepReading = false;
            } else {
                // Assuming the response is text
                const text = new TextDecoder().decode(value);
                response += text;
                console.log('Response while',response);
                console.log('Text while',text);
                if(response.toLowerCase().includes('-r')){
                    keepReading = false;
                }
            }
        }
        console.log('REACH RESPONSE END', response);
        reader.releaseLock();
        writer.releaseLock();
        return response.trim();
    } catch (error) {
        console.error('Error during serial port operation', error);
    } finally {
        console.log('REACHED FINALLY')
    }
}




export const hasBirthdayToday = (bookedUser) => {
    const monthDayFormat = 'MM-DD';
    return moment().format(monthDayFormat) === moment(bookedUser?.birthday).format(monthDayFormat)
}

export const userInHisFirstMonth = (date) => {
    return moment().diff(moment(date), 'month') < 1
}

export const openUpgrade360Link = (payload) => {
    const user = store.getState().user.user;
    const box = store.getState().box.box;
    let extraQs = `profile.studio_name=${box.name || ''}&profile.contact_name=${user.full_name || ''}&profile.contact_phone_number=${user.phone || ''}&email=${user.email || ''}&profile.studio_number=${box.phone || ''}&profile.company_name=Arbox`;
    if (payload?.upchat) {
        extraQs += `&register_upchat=true`;
    }
    fetchApi('integrations/createUuid', 'get', null, false, true).then(uuid => {
        window.open(`${process.env.REACT_APP_UPGRADE_360_REG_URL}?api_key=${uuid}&${extraQs}`, '_blank')
    });
}

export const numberWithCommas = (x) => {
    return x?.toString?.().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatDate = (date) => {
    if (/[0-9]{4}-[0-9]{2}-[0-9]{2}$/y.test(date)) {
        return moment(date).format(getBoxDateFormat());
    }
    if (/[0-9]{4}-[0-9]{2}$/y.test(date)) {
        return moment(date).format('MM/YYYY');
    }
    return date;
}

export const getDateFormatByType = (type, boxDateFormat) => {
    switch (type) {
        case 'week':
          return 'wo/gggg';

        case 'month':
          return boxDateFormat.replace('DD/', '');

        case 'quarter':
          return '[Q]Q/YYYY';

        case 'year':
          return 'YYYY';

        default:
          return boxDateFormat;
      }
}

export const handlePhoneBlur = async (phone, setUserPhoneExist, setFieldValue, lead_id) => {
    if (phone) {
        try {
            const res = await fetchApi('usersBoxes/checkIfValueExists', 'POST', { phone, lead_id }, false, true)
            if (res?.user_fk) {
                setUserPhoneExist(res)
                setFieldValue('phoneValidated', false)
            } else {
                setFieldValue('phoneValidated', true)
            }
        } catch (e) {
            console.log('error in handlePhoneBlur', e)
        }
    }
}

export const handlePersonalIdBlur = async (personal_id, setUserPersonalIdExist, setFieldValue, lead_id = null) => {
    let res
    try {
        if(personal_id) {
            setFieldValue('personalIdValidated', false)
            res = await fetchApi('usersBoxes/checkIfValueExists', 'POST', { personal_id, lead_id }, false, true)
        } if (res?.user_fk) {
            setUserPersonalIdExist(res)
            setFieldValue('personalIdValidated', false)
        } else {
            setFieldValue('personalIdValidated', true)
        }

    } catch (e) {

    }

}

export const handleEmailBlur = async (email, setUserEmailExist, setFieldValue, lead_id = null) => {
    let res
    if(email) {
        setFieldValue('emailValidated', false)
        res = await fetchApi('usersBoxes/checkIfValueExists', 'POST', { email, lead_id }, false, true)
    } if (res?.user_fk) {
        setUserEmailExist(res)
        setFieldValue('emailValidated', false)
    } else {
        setFieldValue('emailValidated', true)
    }
}

export const handleTrackNameBlur = async (name, trackId, setNameWarning) => {
    if (!name) {
        setNameWarning(false)
        return
    }
    try {
        const body = {name}
        if (trackId) body.id = trackId
        const res = await fetchApi('seriesTrack/checkIfNameExists', 'POST', body, false, true)
        setNameWarning(!!res?.exists)
    } catch (e) {
        console.log('error in handleTrackNameBlur', e)
    }
}

export const showIntecom = async () => {
    console.log('[Intercom] showIntecom triggered, ready:', isIntercomReady());
    if (!isIntercomReady()) return;
    const alignment = i18next?.language === 'he' ? 'left' : 'right';
    const jwt = await ensureFreshIntercomJwt();
    callIntercomBoot({
        ...window.intercomSettings,
        ...(jwt ? { intercom_user_jwt: jwt } : {}),
        alignment: alignment,
    });
    intercomSdkShow();
}

/**
 *
 * @param {number} locationId
 * @param {string} setting
 * @returns {boolean} if location has this checkin setting
 */
export const checkinSetting = (locationId, setting) => {
    const box = store.getState().box.box;
    return !!box?.locations_box?.find(location => location.id === locationId)?.disable_pages_app?.find(locationSetting => locationSetting.section_name === setting);
}

// Network mode: the active branch's effective permission set, falling back to
// the flat list (which is the active branch's set, or the only set when the box
// is not in network mode).
export const resolveEffectivePermissions = (user, activeLocationId) => {
    if (!user) return [];
    if (user.network_management && user.permissions_by_location && activeLocationId != null) {
        const byLocation = user.permissions_by_location[activeLocationId]
            ?? user.permissions_by_location[String(activeLocationId)];
        if (byLocation) return byLocation;
    }
    return user.permissions || [];
}

// Network mode: union of permissions across ALL branches (for menu visibility).
// Non-network boxes fall back to the flat permissions list.
export const resolveUnionPermissions = (user) => {
    if (!user) return [];
    if (user.network_management && user.permissions_by_location) {
        return [...new Set(
            Object.values(user.permissions_by_location)
                .filter(Array.isArray)
                .flat()
        )];
    }
    return user.permissions || [];
}

// Shared branch-select state for network-mode dropdowns.
// includeAllLocations: prepend a synthetic "all locations" option (key/value -1).
// Returns { options, show, disabled, only } where:
// - show: render the control (always true when options exist in network mode, even for a single branch)
// - disabled: true when network mode and exactly one real branch (cannot change)
// - only: the single location object when disabled, else null
export const getBranchSelectState = (locations, permission, user, { includeAllLocations = false, allLocationsLabel = null } = {}) => {
    const u = user ?? store.getState().user.user;
    const filtered = permission
        ? getLocationsForPermission(locations, permission, u)
        : getAllowedLocations(locations, u);
    const realCount = filtered.length;
    const options = includeAllLocations
        ? [{ key: -1, value: -1, label: allLocationsLabel, text: allLocationsLabel }, ...filtered.map(location => ({
            key: location.id,
            value: location.id,
            label: location.location,
            text: location.location,
            location,
        }))]
        : filtered.map(location => ({
            key: location.id,
            value: location.id,
            label: location.location,
            text: location.location,
            location,
        }));
    const isNetwork = !!u?.network_management;
    const disabled = isNetwork && realCount === 1;
    // Non-network: keep legacy hide-when-single behavior. Network: always show when there is at least one branch.
    const show = isNetwork ? realCount >= 1 : realCount > 1;
    return {
        options,
        show,
        disabled,
        only: disabled ? filtered[0] : null,
        realCount,
    };
}

// The currently selected branch id (schedule view selector), used as the key
// into permissions_by_location / to filter branch dropdowns.
export const getActiveLocationId = () => {
    return store.getState().userSettings?.scheduleLocation?.id ?? null;
}

// Network mode: only the branches the user is allowed to access. Non-network
// boxes (or callers without allowed_locations) get the full list unchanged.
export const getAllowedLocations = (locations, user) => {
    const u = user ?? store.getState().user.user;
    if (!u?.network_management || !Array.isArray(u?.allowed_locations)) {
        return locations || [];
    }
    return (locations || []).filter(location =>
        u.allowed_locations.some(id => Number(id) === Number(location.id))
    );
}

// Search-result branch label. Network boxes only expose the allowed branches in
// box.locations_box, so a single allowed branch must still show the label.
export const getClientBranchLabel = (locationName) => {
    if (!locationName) return '';
    const state = store.getState();
    const isMultiBranch = state.user?.user?.network_management || state.box?.box?.locations_box?.length > 1;
    return isMultiBranch ? locationName : '';
}

/** Whole-box settings: true for non-network boxes, or network box-wide BOXADMIN. */
export const canEditBoxWideSettings = (user) => {
    const u = user ?? store.getState().user.user;
    if (!u?.network_management) return true;
    return !!u.can_edit_box_wide_settings;
}

/** Permission expansion across branches (any NULL-location role). Not settings. */
export const isBoxWideUser = (user) => {
    const u = user ?? store.getState().user.user;
    if (!u?.network_management) return true;
    return !!u.is_box_wide;
}

// Network mode: only branches where the user holds `permission` (per
// permissions_by_location). Non-network boxes (or no map) get the full list.
// Use this for action-scoped selectors (reports, add customer/lead, finance,
// tasks, etc.) so a branch the user can access but lacks the permission for is
// not offered. Returns [] when the user holds the permission in no branch ->
// callers should show a "no permission" empty state instead of an empty list.
export const getLocationsForPermission = (locations, permission, user) => {
    const u = user ?? store.getState().user.user;
    if (!u?.network_management || !u?.permissions_by_location) {
        return locations || [];
    }
    const required = Array.isArray(permission) ? permission : [permission];
    return (locations || []).filter(location => {
        const perms = u.permissions_by_location[location.id]
            ?? u.permissions_by_location[String(location.id)];
        return Array.isArray(perms) && required.some(p => perms.includes(p));
    });
}

// True when the user holds `permission` in at least one branch (network mode).
// Use for menu/quick-action visibility for branch-scoped writes; pair with
// getLocationsForPermission in the form so only allowed branches are offered.
export const hasPermissionInAnyBranch = (permission, user) => {
    const u = user ?? store.getState().user.user;
    if (!u?.network_management || !u?.permissions_by_location) {
        const perms = u?.permissions || [];
        const required = Array.isArray(permission) ? permission : [permission];
        return required.some(p => perms.includes(p));
    }
    const required = Array.isArray(permission) ? permission : [permission];
    return Object.values(u.permissions_by_location).some(
        branchPerms => Array.isArray(branchPerms) && required.some(p => branchPerms.includes(p))
    );
}

export const hasPermissions = (permissions) => {
    const user = store.getState().user.user;
    const effective = resolveEffectivePermissions(user, getActiveLocationId());
    return permissions.some(p => effective.includes(p))
}

export const hasAllPermissions = (permissions) => {
    const user = store.getState().user.user;
    const effective = resolveEffectivePermissions(user, getActiveLocationId());
    return permissions.every(p => effective.includes(p))
}

export const hasLimitedCoachViewSchedule = () => {
    const user = store.getState().user.user;
    const effective = resolveEffectivePermissions(user, getActiveLocationId());
    return effective.includes('coachViewSchedule') && !effective.includes('viewScheduleV5');
}

export const hasLimitedCoachViewReports = () => {
    const user = store.getState().user.user;
    const effective = resolveEffectivePermissions(user, getActiveLocationId());
    return effective.includes('coachViewReports') && !effective.includes('viewReports');
}

export const openLimitedPackageModal = (dispatch, props = {}) => {
    const modalManagerLimitedPackage = store.getState().modalManager[LIMITED_PACKAGE_MODAL];
    if (modalManagerLimitedPackage?.isOpen) return;
    dispatch(openModal({modalName: LIMITED_PACKAGE_MODAL, props}))
}


export const RoutingFinance = [
    'invoicesAndReceipts',
    'achTransactionsReports',
    'recurringPayments',
    'recurringPaymentsV5',
    'finance',
    'revenue',
    'revenueV5',
    'expenses',
    'deposits',
    'incomes'
];

export const RoutingMoreTools = [
    'inbox-ai',
    'salariesExternal',
    'inventoryExternal',
    'lockers',
    'documentsExternal',
    'settlingAccountsReportExternal',
    'dashboardsExternal',
];

export const RoutingCalendar = [
    'availability',
    'schedule',
    'spaces',
    'calendarOld',
    'calendar',
    'availability-mix'
];

export const NoSidebarRouting = [
    '/external/marketplace',
    '/my-app',
    '/my-links-schedule',
    '/my-links-shop',
];

export const OtherRouting = [
    '/user-profile',
    '/tasks?action=autoTaskSetting',
    '/settings?tab=2',
    '/settings?tab=3'
]

const penaltiesTextWithBlock = {
    en: `Hey {{#first_name#}},\nit has been decided to {{#penalties_type#}}\nThe penalty will begin on {{#start_date#}}, and end on {{#end_date#}}, due to {{#penalties_frequency#}} absences.`,
    he: `היי {{#first_name#}},\nהוחלט על {{#penalties_type#}} מ-{{#start_date#}} עד - {{#end_date#}} עקב {{#penalties_frequency#}} היעדרויות.`
}

export const penaltiesDefaultMessage = {
    block_app_cancel: penaltiesTextWithBlock,
    block_app_no_cancel: penaltiesTextWithBlock,
    block_book_cancel: penaltiesTextWithBlock,
    block_book_no_cancel: penaltiesTextWithBlock,
    no_block_cancel: penaltiesTextWithBlock,
    reduction: {
        en: 'Hey {{#first_name#}},\nit has been decided to {{#penalties_type#}} due to {{#penalties_frequency#}} absences.\nOld end date {{#start_date#}}, New end date {{#end_date#}}',
        he: 'היי {{#first_name#}},\nהוחלט על {{#penalties_type#}} עקב {{#penalties_frequency#}} היעדרויות.\nתאריך סיום ישן {{#start_date#}} ,תאריך סיום חדש {{#end_date#}}'
    }
};

export const getPenaltiesTags = (type) => [
    { id: 'first_name', label: t('firstName') },
    { id: 'last_name', label: t('lastName') },
    { id: 'penalties_type', label: t('penalties-type') },
    ...(type === 'reduction' ? [{ id: 'start_date', label: t('old-end-date') },
    { id: 'end_date', label: t('new-end-date') }] :
    [{ id: 'start_date', label: t('start-date') },
    { id: 'end_date', label: t('end-date') }]),
    { id: 'penalties_frequency', label: t('penalties-frequency') },
    { id: 'classes_penalties', label: t('classes-penalties') },
    { id: 'club_name', label: t('clubName') },
];

export const getMessageTags = () => [
    { id: 'first_name', label:'firstName' },
    { id: 'last_name', label:'lastName' },
    { id: 'date', label:'saleDate', dateType: true },
    { id: 'created_at', label:'createdAt', dateType: true },
    { id: 'age', label:'age' },
    { id: 'membership_type_name', label:'item' },
    { id: 'date', label:'scheduleDate', dateType: true },
    { id: 'time', label:'time', timeType: true },
    { id: 'coach', label:'coaches' },
    { id: 'category', label:'class' },
    { id: 'space', label:'spaceColumn' },
    { id: 'transaction_date', label:'transactionDate', dateType: true },
    { id: 'membership_type_type', label:'item' },
    { id: 'amount', label: 'amount', numType: true },
    { id: 'payments_number', label:'numberOfPayment' },
    { id: 'name', label:'item' },
    { id: 'debt', label:'debt' },
    { id: 'membership_type', label:'membership' },
    { id: 'membership_type', label:'membershipColumn' },
    { id: 'paid', label:'debtOrBalance' },
    { id: 'start', label:'startDateMembership', dateType: true },
    { id: 'membership_type', label:'membershipType' },
    { id: 'end', label:'endDateMembership', dateType: true },
    { id: 'membership_type', label:'session-pack' },
    { id: 'sessions_left', label:'sessionsLeftNum' },
    { id: 'sessions_left', label:'sessionsLeft' },
    { id: 'futureBooking', label:'futureClasses' },
    { id: 'coach', label: 'coach' },
    { id: 'registered_summary', label:'bookings' },
    { id: 'checked_in_summary', label:'checkedIn' },
    { id: 'late_cancellation_summary', label:'lateCancellationReport' },
    { id: 'date', label:'entranceDate', dateType: true },
    { id: 'hour_of_enter', label:'enteringTime', timeType: true },
    { id: 'sessions_left', label:'sessionsLeft' },
    { id: 'time', label:'scheduleTime' , timeType: true},
    { id: 'end_time', label:'endTime' , timeType: true},
    { id: 'category', label:'class' },
    { id: 'lost_reason', label:'leadLostReasons' },
    { id: 'source', label:'source' },
    { id: 'end', label:'expiredDate', dateType: true },
    { id: 'day', label:'day', translate: true },
    { id: 'price', label:'originalPrice' },
    { id: 'name', label:'workshopType' },
    { id: 'end_date', label:'endDate', dateType: true },
    { id: 'lastSeen', label:'lastSeen', dateType: true },
    { id: 'cancellationHours', label:'cancelledHours' },
    { id: 'deleted_at', label:'cancelTime', dateType: true },
    { id: 'created_at', label:'renewDate', dateType: true },
    { id: 'paid', label:'paid' },
    {id: 'remarks', label: t("reason"), translate: true },
    {id: 'convert_link', label: t("link-to-convert") },
    {id: 'membership_link', label: t('link-to-membership')},
    {id: 'transaction_attempts_failed', label: t('attempts')},
    {id: 'amount', label: t("amount")},
    {id: 'debt_amount', label: t("debt-amount")},
    {id: 'debt_link', label: t('link-to-debt')},
    {id: 'confirmation_link', label: t('link-to-confirmation')},
    { id: 'date', label: t('date') },
    { id: 'day', label: t('day'), translate: true },
    { id: 'time', label: t('startTime') },
    { id: 'session_name', label: t('sessionName') },
    { id: 'location', label: t('location') },
    { id: 'end_time_schedule', label: t('end-time') },
    { id: 'note_date', label: t('noteDate'), dateType: true },
    { id: 'note_time', label: t('noteTime')},
    { id: 'all_debts_link', label: t('link-to-all-debts')},
    { id: 'all_debts_amount', label: t("all-debts-amount")},
    { id: 'mu_amount', label: t("mu-amount")},
]

export const getSessionAutoMessageTags = (type, locationTag = false, sessionType = 'appointment') => {
    let tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'time', label: t('startTime') },
        { id: 'end_time', label: t('end-time') },
        { id: 'date', label: t('date') },
        { id: 'day', label: t('day'), translate: true },
        { id: 'session_name', label: t('sessionName') },
        { id: 'coach', label: t('coach') },
        { id: 'space', label: t('space') },
    ];
    if (![autoMessageTypes.MARK_CHECK_IN, autoMessageTypes.CANCEL_SESSION, autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY, autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY, autoMessageTypes.BOOK_SESSION_STAFF_NOTIFY, autoMessageTypes.AFTER_SESSION_NOTIFY, autoMessageTypes.AFTER_SESSION_STAFF_NOTIFY].includes(type) && sessionType === 'appointment') {
        tags.push({ id: 'confirmation_link', label: t('link-to-confirmation'), permission: 'arrivalConfirmations'});
    }
    if (locationTag) {
        tags.push({ id: 'location', label: t('location') });
    }
    //this should always be before the "originals", because the tags order is important
    tags = handleStaffAutoActionTags(tags, type, locationTag)
    if ([autoMessageTypes.EDIT_SESSION, autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY].includes(type)) {
        tags = tags.concat([
            { id: 'original_time', label: t('original-time') },
            { id: 'original_end_time', label: t('original-end-time') },
            { id: 'original_date', label: t('original-date') },
            { id: 'original_day', label: t('original-day') },
            { id: 'original_session_name', label: t('original-session-name') },
            { id: 'original_coach', label: t('original-coach') },
            { id: 'original_space', label: t('original-space') },
        ])
        if(type === autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY) {
            tags = tags.filter(tag => tag.id !== 'original_coach');
        }
    }
    if (type === autoMessageTypes.MARK_CHECK_IN) {
        tags = tags.filter(tag => tag.id !== 'coach');
    }
    if(type === autoMessageTypes.MISSED_TRIAL_SESSION) {
        tags = [
            { id: 'first_name', label: t('firstName') },
            { id: 'last_name', label: t('lastName') },
            { id: 'session_name', label: t('sessionName') },
            { id: 'time', label: t('startTime') },
            { id: 'end_time', label: t('end-time') },
            { id: 'date', label: t('date') },
            { id: 'day', label: t('day'), translate: true }
        ]
    }
    if (type === autoMessageTypes.BEFORE_TRIAL_CLASS || type === autoMessageTypes.AFTER_TRIAL_CLASS) {
        tags = tags.map(tag => tag.id === 'space' ? {...tag, permission: 'spaces'} : tag)
    }
    if ([autoMessageTypes.REMINDER_SESSION, autoMessageTypes.SECOND_REMINDER_SESSION, autoMessageTypes.BOOK_SESSION].includes(type) && sessionType === 'appointment') {
        tags.push({id: 'appointment_qr_link', label: t('appointment-qr-link'), permission: 'burnChipActions'})
    }

    if (type === autoMessageTypes.APPOINTMENT_WAITLIST_OFFER) {
        tags = [
            { id: 'first_name', label: t('firstName') },
            { id: 'last_name', label: t('lastName') },
            { id: 'slot_day', label: t('slot_day'), translate: true },
            { id: 'slot_date', label: t('slot_date') },
            { id: 'slot_time', label: t('slot_time') },
            { id: 'time_to_approve', label: t('time_to_approve') },
            { id: 'approve_link', label: t('appointment-waitlist-offer-link'), isError: true },
        ];
    }
    return tags
}

const handleStaffAutoActionTags = (tags, type, locationTag) => {
    if([autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY, autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY, autoMessageTypes.BOOK_SESSION_STAFF_NOTIFY, autoMessageTypes.AFTER_SESSION_STAFF_NOTIFY].includes(type)) {
        tags = tags.reduce((acc, tag) => {
            if(tag.id === 'first_name') return [...acc, {id: 'staff_first_name', label: t('staffFirstName')}]
            if(tag.id === 'last_name') return [...acc, {id: 'staff_last_name', label: t('staffLastName')}]
            if(['coach', 'original_coach', 'space', 'location'].includes(tag.id)) return acc
            return [...acc, tag]
        }, [])
        tags = tags.concat([
            {id: 'member_full_name', label: t('memberFullName')},
            {id: 'member_phone', label: t('memberPhone')},
            {id: 'space', label: t('space') }, //the order is important to gur
        ])
        if (locationTag) {
            tags.push({ id: 'location', label: t('location') });
        }
        if(type === autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY) {
            tags.push({ id: 'original_staff_first_name', label: t('original_staff_first_name') });
            tags.push({ id: 'original_staff_last_name', label: t('original_staff_last_name') });
        }
    }
    return tags
}

export const targetAudienceTasks = {
    SPECIFIC_USER: 'specific_user',
    GENERAL: 'general',
    PERSONAL: 'personal'
};

export const targetAudienceBulkTasks = {
    ACTIVE_CLIENTS: 'active_clients',
    INACTIVE_CLIENTS: 'inactive_clients',
    LEADS_IN_PROGRESS: 'leads_in_progress',
    LOST_LEADS: 'lost_leads',
}

export const targetAudienceTasksEdit = {
    SPECIFIC_USER: 'specific_user',
    GENERAL: 'general',
    PERSONAL: 'personal'
};

export const specialSignup = ['max', 'tailor-brands'];

export const emojisTranslations = () => ({
    "rtl": isRTL(),
    "search": t("emojies-search"),
    "search_no_results_1": t("emojies-search_no_results_1"),
    "search_no_results_2": t("emojies-search_no_results_2"),
    "pick": t("emojies-pick"),
    "add_custom": t("emojies-add_custom"),
    "categories": {
      "activity": t('emojies-categories-activity'),
      "custom": t('emojies-categories-custom'),
      "flags": t('emojies-categories-flags'),
      "foods": t('emojies-categories-foods'),
      "frequent": t('emojies-categories-frequent'),
      "nature": t('emojies-categories-nature'),
      "objects": t('emojies-categories-objects'),
      "people": t('emojies-categories-people'),
      "places": t('emojies-categories-places'),
      "search": t('emojies-categories-search'),
      "symbols": t('emojies-categories-symbols')
    },
    "skins": {
      "choose": t('emojies-skins-choose'),
      "1": t('emojies-skins-1'),
      "2": t('emojies-skins-2'),
      "3": t('emojies-skins-3'),
      "4": t('emojies-skins-4'),
      "5": t('emojies-skins-5'),
      "6": t('emojies-skins-6')
    }
})

export const getSeriesNameForSort = (seriesName) => {
    const name = (seriesName ?? '').trim();
    const hebrewIndex = name.search(/[\u0590-\u05FF]/);
    if (hebrewIndex === -1) {
        return name;
    }
    return name.slice(hebrewIndex).trim();
};

export const sortString = (text) => {
    if (/[A-Za-z]/.test(text)) {
        return `A_${text}`;
    } else if (/[\u0590-\u05FF]/.test(text)) {
        return `B_${text}`;
    } else if (!isNaN(parseFloat(text))) {
        return `C_${text}`;
    } else {
        return `D_${text}`;
    }
}

export const getSettingsObjectByType = (prop, flows, type) => {
    let settingsObject = {};
    flows.forEach(userType => {
        settingsObject[`${userType}Required`] = getRequiredDefault(prop, userType, type);
    })
    return settingsObject;
}

export const getRequiredDefault = (prop, userType, type = USER_FIELDS) => {
    const box = store.getState().box.box;
    switch (type) {
        case USER_FIELDS:
            if (userType === 'child') {
                if (['first_name', 'last_name', 'personal_id'].includes(prop)) return true;
                return false;
            }
            if (prop === 'first_name') return true;
            if (prop === 'last_name' && userType === 'member') return true;
            if (prop === 'city' || prop === 'address') return box?.locations_box[0]?.country_code !== 'IL';
            return false;
        case USER_SITE_FIELDS:
            if(prop === 'email' && userType === 'child') return false
            if((prop === 'last_name' || prop === 'first_name') && userType === 'child') return true
            if(['first_name', 'last_name', 'email', 'phone'].includes(prop) && userType !== 'child') return true
            else if(prop === 'personal_id' && box?.synced_items_rivhit && userType !== 'child') return true
            return false
        default:
            return false;
    }
}

export const days = () => {
    return ({
        0: { name: t(isMobile ? 'sundayShortened' : 'sunday'), id: 0},
        1: { name: t(isMobile ? 'mondayShortened' : 'monday'), id: 1 },
        2: { name: t(isMobile ? 'tuesdayShortened' : 'tuesday'), id: 2 },
        3: { name: t(isMobile ? 'wednesdayShortened' : 'wednesday'), id: 3 },
        4: { name: t(isMobile ? 'thursdayShortened' : 'thursday'), id: 4 },
        5: { name: t(isMobile ? 'fridayShortened' : 'friday'), id: 5 },
        6: { name: t(isMobile ? 'saturdayShortened' : 'saturday'), id: 6 }
    })
}

export const daysEnum = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
// TODO might get back to it at some point
// export const getFilteredMembership = (memberships, sessionType, planType, itemType, serviceType, workshopType, active, future) => {
//     // if(!memberships || !memberships.membership_types) return [];
//
//     // let result = [...memberships];
//
//     const membershipTypes = [MembershipTypes.SESSION, MembershipTypes.PLAN, MembershipTypes.ITEM, MembershipTypes.SERVICE, MembershipTypes.WORKSHOP];
//
//     return memberships?.filter((membership) => (
//         (!sessionType || membership.membership_types.type === MembershipTypes.SESSION) &&
//         (!workshopType || membership.membership_types.type === MembershipTypes.WORKSHOP)
//     ));
//
// }

export const getBoxSettingProperties = (settingName) => {
    const boxesSettings = store.getState().box.box.settings;
    if(boxesSettings && settingName && boxesSettings[settingName]) return boxesSettings[settingName]
    return null
}

export const getWhiteLabelProperties = () => {
    const whiteLabelProperties = store.getState().box.box.white_label_property?.white_label_properties?.properties
    if(whiteLabelProperties) {
        return {
            authGuard: whiteLabelProperties.authGuard,
            defaultAllLocations: whiteLabelProperties.defaultAllLocations,
            primaryColorRGBA: whiteLabelProperties.primaryColorRGBA,
            mainTabColor: whiteLabelProperties.mainTabColor,
            primaryColor: whiteLabelProperties.primaryColor,
            primaryColorText: whiteLabelProperties.primaryColorText,
            secondaryColor: whiteLabelProperties.secondaryColor,
            secondaryColorText: whiteLabelProperties.secondaryColorText,
        }
    }
    return null
}

export const getSyncConnection = () => {
    const user = store.getState().user.user
    const calendarSync = store.getState().box.box?.calendarSync;
    const userCalendarSync = calendarSync?.find(sync => sync.users_boxes_id === user.id)
    if(userCalendarSync) {
        return {check_for_conflicts: userCalendarSync.check_for_conflicts, add_to_calendar: userCalendarSync.add_to_calendar}
    }
    return null
}
export const fadeIn = (notificationContainer) => {
    notificationContainer.style.transition = 'opacity 0.3s ease, z-index 0s';
    notificationContainer.style.opacity = '1';
    notificationContainer.style.zIndex = '1010';
    notificationContainer.style.pointerEvents = 'auto';

    // Fade in text
    const notificationContent = notificationContainer.querySelectorAll('.ant-notification-notice-message, .ant-notification-notice-description');
    notificationContent.forEach(el => {
        el.style.transition = 'opacity 0.2s ease';
        el.style.opacity = '1';
    });
}

export const fadeOut = (notificationContainer) => {
    notificationContainer.style.transition = 'opacity 0.3s ease, z-index 0s 0.3s';
    notificationContainer.style.opacity = '0';
    notificationContainer.style.zIndex = '-1';
    notificationContainer.style.pointerEvents = 'none';

    // Fade out text slightly after background
    setTimeout(() => {
        const notificationContent = notificationContainer.querySelectorAll('.ant-notification-notice-message, .ant-notification-notice-description');
        notificationContent.forEach(el => {
            el.style.transition = 'opacity 0.2s ease';
            el.style.opacity = '0';
        });
    }, 100);
}
export const getUserTimeCardStatus = () => {
    const user = store.getState().user.user;
    const box = store.getState().box.box;
    const timeCardActive = user?.time_card[user?.time_card?.length - 1]?.exit_date_time === null;

    let timeCardStatus = false;
    if ((box.time_card === 1 || box.time_card === 2) && box.time_card_in === false) {
        timeCardStatus = false;
    } else if((box.time_card === 1 || box.time_card === 2) && timeCardActive === false && !box.time_card) {
        timeCardStatus = false;
    } else if (box.time_card && box.time_card_in && !timeCardActive) {
        timeCardStatus = true;
    } else if ((box.time_card === 1 || box.time_card === 2) && timeCardActive === true) {
        timeCardStatus = true;
    }
    return timeCardStatus;
}

export const openWhatsapp = (phone, message) => {
    const box = store.getState().box.box;
    const countryCode = box.locations_box[0]?.country_code;
    const formattedPhone = getFormattedPhone(phone, countryCode)?.replace(/\D/g, '');
    const whatsappMessage = message ? `&text=${encodeURIComponent(message)}` : '';
    window.open(`https://api.whatsapp.com/send?phone=${formattedPhone}${whatsappMessage}`)
}

export const openWhatsappWithoutPhone = (message) => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`)
}

export const MORE_TOOLS_WHATSAPP_PHONE_CONTACT = '972559928635';

export const openToolLockWhatsapp = (toolTitleKey) => {
    const message = t('toolLockedWhatsappMessage', { tool: t(toolTitleKey) });
    window.open(`https://api.whatsapp.com/send?phone=${MORE_TOOLS_WHATSAPP_PHONE_CONTACT}&text=${encodeURIComponent(message)}`);
};

export const createTinyUrl = async (url) => {
    try {
        const response = await fetchApi('getShortenLink', 'POST', {url}, false, true);
        return response || url
    } catch (e) {
        return url
    }
}

export function htmlToPlainText(html, firstLine = false) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if(firstLine) {
        const firstBlock = doc.body.querySelector('p, div, li, h1, h2, h3, h4, h5, h6');
        return (firstBlock ? firstBlock.textContent : doc.body.textContent).trim() || '';
    }
    return doc.body.textContent || '';
}

export const checkRestrictions = async (type, queryFilter, isUpdate, dispatch, onSuccess, onError) => {
    try {
        const response = await fetchApi('boxes/restrictions', 'POST', {type, queryFilter, isUpdate}, false, true);
        onSuccess?.(response);
    } catch (error) {
        openLimitedPackageModal(dispatch, {limitExceeded: error?.error?.messageToUser})
        onError?.(error);
    }
}

export const logExportAction = (subAction, type) => {
    const isFromArgaz = store.getState().auth?.data?.originalUser;
    if (!subAction || isFromArgaz) return;
    fetchApi('users/logExportAction', 'POST', { subAction, type }, false, true).catch(() => {});
}

export const callManageLog = (name = 'manage-log', data = {}) => {
    try {
        callServerLog(name, data)
    } catch (e) {
        callServerLog(name, data)
    }
}

const callServerLog = async (name, data) => {
    try {
        // const userBox = store.getState().user?.activeUsersBoxes;
        // const cart = data.values?.cart ?? null
        // const cartFirstItem = cart && cart.length ? cart[0] : null
        //
        // const response = await fetchApi('payment/addManageLog', 'POST', {
        //     name,
        //     data,
        //     membership_type_id: cartFirstItem?.id ?? null,
        //     user_id: userBox?.user_fk ?? null
        // }, false, true);
    } catch (e) {
        console.log('error logging to server', e)
    }
}

export const getDefaultArrivalStatuses = (confirmedStatus) => {
    return ([
        {
            id: ArrivalStatuses.BOOKED,
            status: ArrivalStatuses.BOOKED,
            name: t('booked-option'),
            arrival_color: Colors.newDesign.registeredTagColor
        },
        {
            ...confirmedStatus,
        },
        {
            id: ArrivalStatuses.ARRIVED,
            status: ArrivalStatuses.ARRIVED,
            name: t('arrived-option'),
            arrival_color: Colors.newDesign.checkedInTagColor
        }
    ])
}

export const updatePaymentProcessInDB = async ({uuid, values, paymentProcessToken}) => {
    try {
        if (uuid) {
            const flowConfig = store.getState().stepper
            const requestValues = getRequestReadyValues(values)
            const headers = getWebHeadersJson(false, true)
            const {route, method} = getFlowEndpoint(values)
            const endpoint = `${process.env.REACT_APP_NEW_API_URL}${route}?XDEBUG_SESSION_START=PHPSTORM`;
            let flowName = flowConfig.name
            if (values.flowName === flowOptions.ANGULAR_PAYMENT_FLOW) {
                flowName = values.flowName
            } else if(flowName === flowOptions.PAYMENT_FLOW && flowConfig.previousState?.name) {
                flowName = flowConfig.previousState.name
            } else if(!flowName && values.flowName) {
                flowName = values.flowName
            }
            if(!route) window.location.reload()
            const params = {
                values: {...requestValues, flowName},
                endpoint_route: endpoint,
                endpoint_headers: headers,
                endpoint_method: method,
                flow_name: flowName
            }
            const uuidPayment = await fetchApi(`payment/updatePaymentProgress`, 'POST', {uuid, params, paymentProcessToken}, false, true)
        }
    } catch(error) {
        console.log('error', error)
        callManageLog(paymentLogs.uuidPaymentLogError, {error})
        setTimeout(() => window.location.reload(), 10)
    }
}

export const getBoxSegment = (box) => {
    return box?.box_type?.translations?.segment || null;
}

export const handlePricingWithCurrency = (label, currencySymbol) => {
    return `${isRTL() ? '' : currencySymbol} ${label} ${isRTL() ? currencySymbol : ''}`
}

// Known non-Google email providers (for Google Calendar sync compatibility check)
const NON_GOOGLE_EMAIL_DOMAINS = [
    'outlook.com', 'hotmail.com', 'live.com', 'msn.com', // Microsoft
    'yahoo.com', 'ymail.com', // Yahoo
    'walla.co.il', 'walla.com', // Walla
    'aol.com', // AOL
    'icloud.com', 'me.com', 'mac.com', // Apple
    'protonmail.com', 'proton.me', // ProtonMail
    'mail.ru', // Mail.ru
    'zoho.com', // Zoho
    'gmx.com', 'gmx.net', // GMX
    'yandex.com', 'yandex.ru', // Yandex
];

/**
 * Checks if an email address is from a known non-Google email provider
 * @param {string} email - The email address to check
 * @returns {boolean} - True if the email is from a non-Google provider
 */
export const isNonGoogleEmail = (email) => {
    if (!email || typeof email !== 'string') return false;
    const domain = email.split('@')[1]?.toLowerCase();
    return NON_GOOGLE_EMAIL_DOMAINS.includes(domain);
}

/**
 * Sorts coaches for sync invite selection with "All coaches" option first
 * Excludes the current user from the list
 * Uses the same sorting logic as AdvanceSelect component
 * @returns {Array} - Array of coach options with "All coaches" first, then sorted coaches
 */
export const getSortedCoachesForSyncInvite = () => {
    const currentUser = store.getState().user.user;
    const storeCoaches = store.getState().schedule.coaches
    const coaches = storeCoaches ? [...storeCoaches] : null;

    // Filter out the current user
    const filteredCoaches = coaches?.filter(coach => coach.user_fk !== currentUser.user_fk) || [];

    // Sort using the same logic as AdvanceSelect
    const ordered = orderBy(filteredCoaches, ['active', coach => `${coach.first_name} ${coach.last_name || ''}`.toLowerCase()], ['desc', 'asc']);
    const sorted = sortBy(ordered, [
        coach => coach.status_fk === 1027 ? 1 : 0
    ]);


    return [
        {id: 'all', value: 'all', label: t('all-coaches'), shortLabel: t('all-coaches'), isDisabled: false},
        ...sorted.map(coach => ({
            ...coach,
            ub_id: coach.id,
            id: coach.user_fk,
            value: coach.user_fk,
            label: `${coach.first_name} ${coach.last_name || ''} | ${getKeyByCase(coach)}`,
            shortLabel: `${coach.first_name} ${coach.last_name || ''}`,
            isDisabled: !coach.email || isNonGoogleEmail(coach.email) || coach.pending
        }))
    ];
}

export const sortByScript = (items, getNameFn) => {
    const getScriptGroup = (item) => {
        const firstChar = (getNameFn(item) || '').trimStart()[0] || '';
        if (/[a-zA-Z]/.test(firstChar)) return 0;
        if (/[\u05D0-\u05EA]/.test(firstChar)) return 1;
        return 2;
    };
    return sortBy(items, [getScriptGroup, item => (getNameFn(item) || '').toLowerCase()]);
};

const getKeyByCase = (coach) => {
    if(!coach.email) {
        return t('no-email-for-sync')
    } else if(isNonGoogleEmail(coach.email)) {
        return t('no-google-email')
    } else if(coach.pending) {
        return t('pending-merge')
    } else {
        return coach.email
    }
}

export const isValidIsraeliID = (id) => {
    return id && id.length <= 9 && !isNaN(id) && id.padStart(9, '0').split('').reduce((acc, digit, index) => {
        let num = Number(digit) * ((index % 2) + 1);
        if (num > 9) num -= 9;
        return acc + num;
    }, 0) % 10 === 0;
}

export const formatPriceWithCurrencyLTR = (amount, currencySymbol) =>
    `\u200e${currencySymbol}${amount?.toLocaleString()}`

export const getHugFormattedDaysAndDate = ({ eventData, bookingType, selectedSeriesEvents, boxLocale, timeFormat, HUG_FULL_BOOKING }) => {
    const seriesEvents = eventData?.series?.series_events?.map(seriesEvent => ({
        id: seriesEvent.id,
        daysAndHours: `${moment().weekday(seriesEvent.day_of_week).locale(boxLocale).format('dddd')}: ${moment(seriesEvent.start, dbTimeFormat).locale(boxLocale).format(timeFormat)} - ${moment(seriesEvent.end, dbTimeFormat).locale(boxLocale).format(timeFormat)}${seriesEvent.description ? ` - ${seriesEvent.description}` : ''}`,
    }));

    const selectedDays = bookingType !== HUG_FULL_BOOKING
        ? seriesEvents?.filter(se => selectedSeriesEvents?.includes(se.id)).map(se => se.daysAndHours)
        : seriesEvents?.map(se => se.daysAndHours);

    const formatDate = (date) => moment(date).locale(boxLocale).format(boxLocale === 'he' ? 'D MMM, YYYY' : 'MMM D, YYYY');
    const startDate = formatDate(eventData?.date || eventData?.series?.start_date);
    const endDate = eventData?.series?.end_date
        ? formatDate(eventData.series.end_date)
        : bookingType === HUG_FULL_BOOKING
            ? t('no-end-date-hugim', { startDate })
            : null;

    return {
        dateRange: endDate ? `${startDate} - ${endDate}` : startDate,
        daysAndHours: selectedDays?.join('\n') ?? '',
    };
};

export const getHugSeriesEventOptions = (eventData, boxTimeFormat) =>
    eventData?.series?.series_events?.map(day => {
        const isOpen = eventData.series.openDays?.some(op => op.id === day.id);
        return {
            ...day,
            value: day.id,
            label: `${t(`partial-day-checkbox-${isOpen ? 'open' : 'full'}`, {
                day: t(`days-${day.day_of_week}`),
                start: moment(day.start, dbTimeFormat).format(boxTimeFormat),
                end: moment(day.end, dbTimeFormat).format(boxTimeFormat),
                interpolation: { escapeValue: false },
            })}${day.description ? ` - ${day.description}` : ''}`,
            disabled: !isOpen,
        };
    });

export const getBookingOptionLabel = (numOfDays) =>
    numOfDays
        ? t(`partial-${numOfDays === 1 ? 'single' : 'multi-days'}-course-select-btn`, {num: t(`${numOfDays}-days`)})
        : t('bookEntireHugOption');

export const sortCourseEventDays = (days) => {
    let sorted = [...days]
    sorted.sort((day1, day2) => {
        if(!isBoxIL()) {
            day1 = day1.day_of_week === 0 ? 7 : day1.day_of_week;
            day2 = day2.day_of_week === 0 ? 7 : day2.day_of_week;
        }
        return day1 - day2
    })
    return sorted
}

const callInsertToScheduleUser = async (path, params, dataEvent) => {
    await fetchApi(path, 'post', params, false, true);
    sendDataEvent(dataEvent);
}

export const bookingWithoutMembership = async (data, fromSelectMembership = null, force = null, fromReviveScheduleUser = null, bookedFromHug = null, bookWithoutMembership = null, eventData, path) => {

    data['schedule_id'] = eventData.id;
    const params = {
        force: force,
        user_fk: data.user_fk,
        schedule_id: data.schedule_id,
        membership_user_id: fromReviveScheduleUser ? null : !bookedFromHug ? (data.membership_user_id || data.membership_user_fk || null) : null, //forcing m.u to be null on one time Hug
        late_cancellation_user: data.late_cancellation,
        is_lead: data.type === LEAD_TYPE,
        bookedFromHug: bookedFromHug,
        bookWithoutMembership: fromReviveScheduleUser ? true : bookWithoutMembership
    };
    await callInsertToScheduleUser(path + '/insert',
        params,
        'Toast-' + (path === 'scheduleUser' ? 'userAddedToClassSuccessfully' : 'userAddedToWaitingListSuccessfully'));

}

export const checkBoxHasDoctorJournal = ({has}) => {
    const doctor_journal_settings = store.getState().box?.box?.settings?.doctor_journal_settings
    if(has) {
        return has('doctorJournalSettings') && doctor_journal_settings?.enabled
    } else {
        const permissions = store.getState().user?.user?.permissions ?? [];
        return permissions.includes('doctorJournalSettings') && doctor_journal_settings?.enabled
    }
}

export const resolveEventCategoryType = (eventType) => {
    if(eventType === HUGIM_FROM_TRACK) {
        return 'hugim'
    }
    return null
}

export const getPartialAttendanceDisplay = (dayId, hug) => {
    let registrations_count
    let openDay = hug.openDays?.find(openDay => openDay.id === dayId)
    if(!openDay) {
        registrations_count = hug.max_users
    } else {
        registrations_count = openDay.registrations_count || 0
    }
    return `${registrations_count}/${hug.max_users}`
}

export const getGroupLinkContactHelper = ({ connections, memberUserFk, includePhone = true, includeEmail = true }) => {
    const list = Array.isArray(connections) ? connections : (connections?.data ?? []);
    if (!list.length || (!includePhone && !includeEmail)) return null;

    const memberConn = list.find(conn => conn.user_box?.user_fk === memberUserFk);
    const headConn = list.find(conn => conn.head === 1);

    // Only when the target is a group member with a separate Head of Group.
    if (!memberConn || !headConn || memberConn.user_box?.user_fk === headConn.user_box?.user_fk) return null;

    // Classify each selected channel: 'also' | 'toHead' | 'notSent' | 'memberOnly'.
    const classify = (memberHas, headHas) => {
        if (memberHas && headHas) return 'also';
        if (!memberHas && headHas) return 'toHead';
        if (!memberHas && !headHas) return 'notSent';
        return 'memberOnly';
    };
    const phoneClass = includePhone ? classify(!!memberConn.user_box?.phone, !!headConn.user_box?.phone) : null;
    const emailClass = includeEmail ? classify(!!memberConn.email, !!headConn.email) : null;

    // If every selected channel can't reach anyone, nothing will be sent -> red error.
    const activeClasses = [phoneClass, emailClass].filter(Boolean);
    const allNotSent = activeClasses.length > 0 && activeClasses.every(c => c === 'notSent');
    if (allNotSent) {
        if (includePhone && includeEmail) return { text: t('groupLinkHelperNoContact'), severity: 'error' };
        return { text: t(includePhone ? 'groupLinkHelperSmsNotSent' : 'groupLinkHelperEmailNotSent'), severity: 'error' };
    }

    const parts = [];

    if (phoneClass === 'also') parts.push(t('groupLinkHelperSmsAlsoToHead'));
    else if (phoneClass === 'toHead') parts.push(t('groupLinkHelperSmsSentToHead'));
    else if (phoneClass === 'notSent') parts.push(t('groupLinkHelperSmsNotSent'));

    if (emailClass === 'also') parts.push(t('groupLinkHelperEmailAlsoToHead'));
    else if (emailClass === 'toHead') parts.push(t('groupLinkHelperEmailSentToHead'));
    else if (emailClass === 'notSent') parts.push(t('groupLinkHelperEmailNotSent'));

    if (!parts.length) return null;

    return { text: parts.join(' '), severity: 'helper' };
}
export const getAccountGroupOptions = (data) => {
    const grouped = _.groupBy(data, 'account_group');
    return _.map(grouped, (items) => ({
        label: _.map(items, 'location').join(', '),
        value: _.map(items, 'id'),
    }));
}

/**
 * Finance location chip options.
 * Network boxes with profit centers (project_id): one option per allowed branch.
 * Otherwise: existing account_group grouping (regular boxes unchanged).
 */
export const getFinanceLocationOptions = (locations, user) => {
    const allowed = getLocationsForPermission(locations, 'rivhitFinanceV5', user);
    if (user?.network_management && allowed.some(location => !!location.project_id)) {
        return allowed.map(location => ({
            value: location.id,
            label: location.location,
        }));
    }
    return getAccountGroupOptions(allowed);
}

export const isTrialServiceTypeRowEmpty = (row) => {
    const hasServiceType = row?.box_categories_id != null;
    const hasSessions = row?.trial_limit != null;
    return !hasServiceType && !hasSessions;
};

export const buildTrialServiceTypeLimitsPayload = (rows) => {
    if (!rows?.length) {
        return [];
    }
    return rows.filter(row => !isTrialServiceTypeRowEmpty(row)).map(row => ({
            box_categories_id: row.box_categories_id,
            trial_limit: Number(row.trial_limit),
        }));
};

export const findFormIdByBoxCategories = (formSettings, boxCategoryId) => {
    return formSettings?.find(s => s.properties?.box_categories?.includes(boxCategoryId))?.properties?.form_id
}

export const normalizeText = (text) => text?.replace(/<[^>]*>/g, '')?.trim() ? text : ''
